import { FOfferType } from '../../../utils/offer_type';

export enum ECozyLocales {
  cozyMasculine = 'уютный',
  cozyFeminine = 'уютную',
}

/**
 * Для квартиы, комнаты, дома, таунхауса или офиса прибавляем "уютный/уютную"
 * @param offerType
 */
export function getCozy(offerType: FOfferType): string {
  switch (offerType) {
    case FOfferType.Flat:
    case FOfferType.Room:
    case FOfferType.FlatOld:
    case FOfferType.FlatNew:
      return ECozyLocales.cozyFeminine;
    case FOfferType.House:
    case FOfferType.Townhouse:
    case FOfferType.Office:
      return ECozyLocales.cozyMasculine;
    default:
      return '';
  }
}
